import React, { useEffect, useRef } from 'react';
import './Footer.css';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaYoutube, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const footerRef = useRef(null);

  useEffect(() => {
    const currentFooter = footerRef.current;  // capture ref.current

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      },
      {
        threshold: 0.3,
      }
    );

    if (currentFooter) {
      observer.observe(currentFooter);
    }

    return () => {
      if (currentFooter) {
        observer.unobserve(currentFooter);
      }
    };
  }, []);

  return (
    <div className="footer" ref={footerRef}>
      <div className="footer-content">
        <div className="footer-top">
          <p>© 2025 MANDI HARIYANNA Academy. All rights reserved.</p>
          <p>Developed by Sathish Kumar D .</p>
          <div className="footer-links">
            <ul>
              <li><a href="https://youtu.be/LSD-qYSgBDk?si=6btEdssDcM1QTm9R" target="_blank" rel="noopener noreferrer"><FaYoutube /> YouTube</a></li>
              <li><a href="https://www.instagram.com/reel/DLg-u1SSs-C/?igsh=NHc5Njl4NmN2aW5r" target="_blank" rel="noopener noreferrer"><FaInstagram /> Instagram</a></li>
              <li><a href="https://www.example.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
              <li><a href="https://www.example.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-contact-map">
          <div className="footer-contact">
            <div className="footer-address">
              <h4>Our Address:</h4>
              <p><FaMapMarkerAlt /> MANDI HARIYANNA Academy, Mahalakshmi Layout, Bengaluru, Karnataka 560086</p>
            </div>

            <div className="footer-phone">
              <h4>Phone Number:</h4>
              <p><FaPhoneAlt /> +91 9113647474</p>
            </div>

            <div className="footer-email">
              <h4>Email:</h4>
              <p><FaEnvelope /> mhskill2024@gmail.com</p>
            </div>
          </div>

          <div className="google-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.032798360707!2d77.54314087491167!3d13.003518287290636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d007d7638cb%3A0xa1dea249aca66989!2sPoojya%20Mandi%20Hariyanna%20Academy!5e0!3m2!1sen!2sin!4v1712678344651!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="MANDI HARIYANNA Academy - Bangalore"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
